import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import CheckIcon from '@material-ui/icons/Check'
import ErrorIcon from '@material-ui/icons/ErrorOutline'

import './ui.scss'

const Alert = (props) => <MuiAlert elevation={6} variant="filled" {...props} />
const SnackbarIcons = {
  success: <CheckIcon fontSize="inherit" />,
  error: <ErrorIcon fontSize="inherit" />,
}
const DURATION_MS = 10000 // show notification for 10 seconds

const Notification = ({
  open = false,
  severity = '', // 'success' || 'error'
  message = '',
  Component,
  componentProps = {},
  onClose,
}) => {
  const handleCloseSnackbar = () => {
    onClose?.({ open: false, message: '', severity: '' })
  }

  if (!severity || !open) return null

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={DURATION_MS}
      className="wobo-snackbar"
      onClose={handleCloseSnackbar}
      open={open}
    >
      <Alert
        onClose={handleCloseSnackbar}
        severity={severity}
        icon={SnackbarIcons[severity]}
      >
        {message}
        {Component ? <Component {...componentProps} /> : <></>}
      </Alert>
    </Snackbar>
  )
}

export default Notification
